import { useEffect } from "react";
import effects from "./json/effects-id-data.json";
import { useScore } from "./context/ScoreContext";
const Category = (props) => {

    const { cs } = useScore();

    // console.log( );
    const category = { 1: "Class", 2: "Rarity", 3: "Attribute", 4: "Skill", 5: "Gender", 6: "NP-Card", 7: "NP-Type", 8: "Card-Deck" };
    const classes = {
        1: "Saber", 2: "Archer", 3: "Lancer", 4: "Rider", 5: "Caster", 6: "Assassin", 7: "Berserker", 8: "Shielder",
        9: "Ruler", 10: "Alter-Ego", 11: "Avenger", 23: "Moon Cancer", 25: "Foreigner", 28: "Pretender", 33: "Beast Draco", 34: "Beast Eresh"
    };
    const rarity = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 };
    const attribute = { 1: "Man/Human", 2: "Earth", 3: "Sky", 4: "Star", 5: "Beast" };
    const gender = { 1: "Male ♂️", 2: "Female ♀️", 3: "Unknown❔" };
    const NPcard = { 1: "Buster", 2: "Arts", 3: "Quick" };
    const NPtype = { 1: "AOE", 2: "Single-target", 3: "Support" };
    const deck = { 1: "qaabb", 2: "qqaab", 3: "qqabb", 4: "qqqab", 5: "qaaab", 6: "qabbb" };
    const hitTypes = { 1: '=1', 2: '≥5', 3: '<5', 4: '≥10' }
    const classAffinty = { 1: "Effective", 2: "Neutral", 3: "Weak" }
    const alignments = { 1: "Lawful", 2: "Good", 3: "Evil", 4: "Chaotic", 5: "Balanced", 6: "Neutral" }
    const traits = {
        "9": "Dragon", "10": "Saberface", "11": "Riding",
        "12": "Arthur", "13": "King", "14": "Knights Of The Round", "15": "FSN servant", "16": "Roman", "17": "Dragon Slayer", "18": "Divine", "19": "Shinsengumi Servant",
        "20": "Mechanical", "21": "Summer Mode Servant", "22": "Genji", "23": "Child servant", "24": "FairyTale servant", "25": "Levitating", "26": "Defender",
        "27": "Threat To Humanity", "28": "Demonic", "29": "Beast", "30": "Fae", "31": "Moon", "32": "Existence Outside The Domain", "33": "Super Giant", 34: "Has Costume"
    };
    const effectType = { 1: "Buff", 2: "Debuff" }

    const parseClassAffinty = (aff) => {
        // console.log(typeof aff);
        if (!aff || typeof aff === 'number') return { 'affinity': '1', 'classId': '5' };
        if (!aff.includes('|')) {
            return { 'affinity': '1', 'classId': '5' };
        }
        return { "affinity": aff.split("|")[0], "classId": aff.split("|")[1] }
    }
    const parseEffect = (effString) => {
        if (!effString || typeof effString === 'number') return { 'type': '1', 'id': '1' };
        if (!effString.includes('|')) {
            return { 'type': '1', 'id': '1' };
        }
        const type = effString.split("|")[0];
        const id = effString.split("|")[1];
        return { "type": type, "id": id }
    }

    const getTraitTooltipText = (traitId) => {
        if (!traitId) return "";
        switch (traitId) {
            case '15':
            case '19':
            case '23':
            case '24':
                return `is a ${traits[traitId]} in any ascension`;
            case '21': return `is a summer servant or has summer costume`;
            case '25': return `is levitating in any ascension`;
            case '34': return `has a costume`;
            default: return `has the ${traits[traitId]} trait`;
        }
    }

    const getNPhitTooltipText = (hit) => {
        if (!hit) return "";
        switch (hit) {
            case '1': return `has NP that hits exactly once per ememy`;
            case '2': return `has NP that hits 5 or more times per ememy`;
            case '3': return `has NP that hits less than 5 times per ememy (support NPs don't count)`;
            case '4': return `has NP that hits 10 or more times per ememy`;
            default: return "";
        }
    }

    const effectTooltipTargetText = { 1: "party/self", 2: "enemy" }

    const catID = Object.keys(props.data)[0];
    const catTypeID = Object.values(props.data)[0];
    // console.log(catID, catTypeID);

    const skill = {};
    skill[catTypeID] = catTypeID;
    // const categoryData = {0:{0:"Blank"}, 1:classes, 2:rarity, 3:attribute, 4:skill}
    const attributeIcons = { 1: '🙍', 2: '🌏', 3: '🌌', 4: '🌠', 5: '🦁' };
    const affinityColors = { 1: "red", 2: "purple", 3: "blue" }
    // const npCardIcons = `${NPcard[catTypeID].toLowerCase()}.png`;
    const categoryTitle = {
        0: <p></p>, 1: <p>Class:</p>, 2: <p>Rarity:</p>, 3: <p>Attribute:</p>, 4: <p>Learns Skill:</p>,
        5: <p>Gender:</p>, 6: <p>NP:</p>, 7: <p>NP:</p>, 8: <p>Deck:</p>, 9: <p>NP Hit-Count:</p>,
        10: <p>Does <span style={{ color: affinityColors[parseClassAffinty(catTypeID)['affinity']] }}>{classAffinty[parseClassAffinty(catTypeID)['affinity']]}</span> damage to:</p>,
        11: <p>Trait:</p>, 12: <p>Alignment:</p>, 13: <p>Apply {effectType[parseEffect(catTypeID)['type']]}:</p>
    };

    const categorySubTitle = {
        0: <img src={`commandSpell${cs}.png`} className="command-spell" width={"50%"} alt="" />,
        1: <img src={`https://static.atlasacademy.io/JP/ClassIcons/class3_${catTypeID}.png`} width={"35%"} alt="" />,
        2: <img src={`star${catTypeID}.png`} style={{ maxWidth: "80%" }} alt="" />,
        3: <p>{attributeIcons[catTypeID]}
            ({attribute[catTypeID]})</p>,
        4: <img src={`https://static.atlasacademy.io/JP/SkillIcons/skill_${catTypeID}.png`} width={"35%"} alt="" />,
        5: <p>{gender[catTypeID]}</p>,
        6: <img src={`${NPcard[catTypeID]}.png`} style={{ maxWidth: "50%" }} alt="" />, //TODO
        7: <p>{NPtype[catTypeID]}</p>,
        8: <img src={`${deck[catTypeID]}.webp`} width={"90%"} alt="" />,
        9: <p>{hitTypes[catTypeID]}</p>,
        10: <img src={`https://static.atlasacademy.io/JP/ClassIcons/class3_${parseClassAffinty(catTypeID)['classId']}.png`} width={"35%"} alt="" />,
        11: <p>{traits[catTypeID]}</p>,
        12: <p>{alignments[catTypeID]}</p>,
        13: <div style={{ textAlign: "center", fontSize: "1em" }}><p>{effects[parseEffect(catTypeID)['id']]['name']}</p>
            <img className='buff-icon' src={`https://static.atlasacademy.io/JP/BuffIcons/bufficon_${effects[parseEffect(catTypeID)['id']]['icon']}.png`} alt="" /></div>
    };

    const NPtypeToolTip = { 1: "a damaging AOE", 2: "a damaging single-target", 3: "a non-damaging" };
    const categoryTooltip = {
        0: `Command Spell ${cs}/3, click on a cell to use`,
        1: `is of ${classes[catTypeID]} class`,
        2: `is ${rarity[catTypeID]}-star`,
        3: `has ${attribute[catTypeID]} attribute`,
        4: `learns skill with this icon (includes pre-strengthning skills)`,
        5: `gender, as listed in the game`,
        6: `has ${NPcard[catTypeID]} Noble Phantasm`,
        7: `has ${NPtypeToolTip[catTypeID]} Noble Phantasm`,
        8: `has ${deck[catTypeID]?.toUpperCase()} Card deck`,
        9: getNPhitTooltipText(catTypeID),
        10: `does ${classAffinty[parseClassAffinty(catTypeID)['affinity']]} damage to ${classes[parseClassAffinty(catTypeID)['classId']]} class servants`,
        11: getTraitTooltipText(catTypeID),
        12: `has ${alignments[catTypeID]} alignment`,
        13: `can apply this ${effectType[parseEffect(catTypeID)['type']]} on ${effectTooltipTargetText[parseEffect(catTypeID)['type']]} with skills or NP`
    };


    const info = categoryTooltip[catID];

    return (
        <div className={props.classType}
            data-tooltip-id="category-tooltip"
            data-tooltip-content={info}>

            {categoryTitle[catID]}
            {categorySubTitle[catID]}

        </div>
    );
}

export default Category;